/**
 * Ness Frame Character - Frontend 전용 네임스페이스
 *
 * 사용법:
 * import { NessLabsFrameF } from '@modules/NessLabs/Frame/F';
 *
 * NessLabsFrameF.checkCharacterImageOpaqueArea({ image_url })
 * NessLabsFrameF.SelectedOptionGroupForFrameCharacter.setBpOptionOutputForBpOptionId(id)
 * NessLabsFrameF.loadProductDetailForFrame(el)
 * NessLabsFrameF.makeCharacterCanvas(image_url, options)
 */

import { checkCharacterImageOpaqueArea } from './checker';
import { SelectedOptionGroupForFrameCharacter } from './selected-option-group';
import { loadProductDetailForFrame, makeCharacterCanvas } from './load-product-detail';

export const NessLabsFrameF = {
  checkCharacterImageOpaqueArea,
  SelectedOptionGroupForFrameCharacter,
  loadProductDetailForFrame,
  makeCharacterCanvas,
};
